// extracted by mini-css-extract-plugin
export default {"cls1":"ebd8hE1jWdtNALNNI99Y","cls2":"DgCypTMn_AmJqioelrPA ebd8hE1jWdtNALNNI99Y"};